export class MigrationResult {
  constructor(version, data) {
    this.version = version;
    this.data = data;
  }
}